<template>
  <div id="app">
    <router-view v-if="routerAlive"/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      routerAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.routerAlive = false
      this.$nextTick(() => {
        this.routerAlive = true
      })
    },
  },
  created() {
    var urlParams = new URLSearchParams(window.location.search); //获取URLSearchParams对象
    var paramObj = {}; //声明一个空对象，用于保存参数
    if (urlParams) {
      urlParams.forEach(function (value, key) {
        paramObj[key] = value; //将键值对存入对象
      });
    }
    if (paramObj.token) {
      this.$store.dispatch("setToken", {
        token: paramObj.token
      });
    }
  }
}
</script>

<style lang="scss">
@import './styles/index.scss';

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  overflow: hidden;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  min-height: 100vh;
  background-image: url("~@/assets/images/bg.jpg");
}
.el-tooltip__popper{
  max-width: 500px !important;
}
</style>
